module.exports = __webpack_public_path__ + "img/logo-megaphone.00adcc33.svg";